<div class="search-result">
  <div class="container">
    <app-gallery-title [keyword]="keyword" />
    <app-gallery-tags />
  </div>
</div>
<div class="filter">
  <app-pricing-filter />
  <app-content-type-filter />
  <app-orientation-filter />
  <app-sorting-options />
</div>

@if (images$ | async; as images) {
  <app-gallery [galleryItems]="images" [columns]="5" />
  @if (hasMoreResults$ | async) {
    <app-gallery-items-load-more (loadMore)="onLoadMore()" />
  }
}
